export default __webpack_public_path__ + "locales/az/SingleSignOn.json?hash=36c19002af288f47e93be9ddd8dfa31c";